// extracted by mini-css-extract-plugin
module.exports =  {"root":"JzSBGzSgPdd16Vw_w785","description":"mo2l_9hUC36n4cT6ELLi"};